import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

import regexp from '@/common/regexp';

const ERROR_QUERY_KEY = 'error_description';

const useLogSSOError = () => {
  const location = useLocation();
  const [isLogged, setIsLogged] = useState(false);

  const hasError = useMemo(() => location.hash.includes(ERROR_QUERY_KEY), [location.hash]);

  useEffect(() => {
    if (!hasError || isLogged) return;

    setIsLogged(true);

    const params = new URLSearchParams(location.hash.replace(regexp.HASH_PREFIX, ''));
    const ssoErrorFromHash = Object.fromEntries(params);
    const errorCode = ssoErrorFromHash.error ?? 'unknown';

    datadogRum.addError(new Error(`SSO_${errorCode}`), {
      source: 'sso',
      flow: 'login',
      errorCode: ssoErrorFromHash.error,
      errorDescription: ssoErrorFromHash.error_description,
      rawHash: location.hash,
    });
  }, [hasError, isLogged, location.hash]);
};

export default useLogSSOError;
